import script from "./marketing.vue?vue&type=script&lang=ts&setup=true"
export * from "./marketing.vue?vue&type=script&lang=ts&setup=true"

import "./marketing.vue?vue&type=style&index=0&id=7a484402&lang=less&scoped=true"

import exportComponent from "D:\\test\\ieds-user-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a484402"]])

export default __exports__